var _this = this;
import * as tslib_1 from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { productMapper } from '@wix/wixstores-platform-common/dist/src/products/product.mapper';
import { query } from '../graphql/getProducts.graphql';
import { query as slugQuery } from '../graphql/getProductsBySlug.graphql';
export function getProductBySlug(siteStore, slug, externalId) {
    // const productsQueryVariables = {
    //   limit: 1,
    //   filters: {term: {field: 'slug', op: 'EQUALS', values: [slug]}},
    //   externalId,
    // };
    var productsQueryVariables = {
        slug: slug,
        externalId: externalId,
    };
    return siteStore.httpClient.post(siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), {
        query: slugQuery,
        variables: productsQueryVariables,
        source: 'WixStoresWebClient',
        operationName: 'getProductBySlug',
    });
}
export function getDefaultProduct(siteStore, externalId) {
    var productsQueryVariables = {
        limit: 1,
        sort: { sortField: 'CreationDate', direction: 'Descending' },
        filters: null,
        externalId: externalId,
    };
    return siteStore.httpClient.post(siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), {
        query: query,
        variables: productsQueryVariables,
        source: 'WixStoresWebClient',
        operationName: 'getDefaultProduct',
    });
}
var fetchProduct = function (siteStore) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var encodedProductName, productName, response, json;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedProductName = siteStore.location.path[siteStore.location.path.length - 1];
                productName = decodeURIComponent(encodedProductName);
                return [4 /*yield*/, fetch(siteStore.resolveAbsoluteUrl("/_api/catalog-server/api/v1/products/query"), {
                        method: 'post',
                        headers: { Authorization: siteStore.instance },
                        body: JSON.stringify({
                            query: {
                                filter: JSON.stringify({ slug: productName }),
                            },
                        }),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                return [2 /*return*/, json.products && json.products[0]];
        }
    });
}); };
export function wixCodeGetProduct(siteStore, reportError) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var product, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchProduct(siteStore)];
                case 1:
                    product = _a.sent();
                    if (product) {
                        return [2 /*return*/, productMapper(product)];
                    }
                    else {
                        throw new Error('product not found');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    reportError(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getProduct.js.map